import React from "react";

export default function Footer() {
    //
    return(
        <footer className="Footer">
            <p>Copyright &copy; Shaheen.org #H7N </p> 
        </footer>
    )
}